import Immutable from 'seamless-immutable';

import PropTypes from 'prop-types';

import { actions } from './actions';

const defaultState = {
  working: false,
  error: null,
};

export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.START: {
      return state.merge({
        working: true,
      });
    }
    case actions.SUCCESS: {
      return state.merge({
        working: false,
        error: null,
      });
    }
    case actions.FAIL: {
      const { error } = action.payload;
      return state.merge({
        error,
        working: false,
      });
    }
    default: {
      return state;
    }
  }
}

export const propTypes = {
  working: PropTypes.bool,
  error: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/redux/AcceptInviteForm/reducer.js